import { ComplexValue } from 'app/types-shared';
import { SavedReportDashboard } from '../common/types-store';
import { defaultWidth } from '../constants';

export const createDefaultSavedReport = (code: ComplexValue<number>, sequence: number): SavedReportDashboard => ({
  code,
  selectedReport: undefined,
  editable: false,
  sequence,
  disabled: undefined,
  minWidth: defaultWidth,
  height: undefined
});
